export enum UIElement {
  WELCOME = 'WELCOME',
  SIDEMENU = 'SIDEMENU',
  EXPLANATION = 'EXPLANATION',
  TAGFILTER = 'TAGFILTER',
  KEYWORDFILTER = 'KEYWORDFILTER',
  GEOFILTER = 'GEOFILTER',
  GALLERY = 'GALLERY',
  ABOUT = 'ABOUT',
  QRMODAL = 'QRMODAL',
  CONTROLS = 'CONTROLS',
  LEGALNOTICE = 'LEGALNOTICE',
  TERMSOFUSE = 'TERMSOFUSE',
}
